import { AttributeKind } from 'types/attributes';
import { RoutePaths } from 'types/enums';

export const attributeKindToRoute = (kind?: AttributeKind) => {
    switch (kind) {
        case AttributeKind.Genre:
            return RoutePaths.Genres;
        case AttributeKind.Instrument:
            return RoutePaths.Instruments;
        case AttributeKind.Sfx:
            return RoutePaths.Sfxs;
        default:
            return undefined;
    }
};
